<div class="row div-spacer">	
    <div class="col-sm-7">
        <h2>Learn with your child</h2>
        <p>Decide on the concepts to be tested and covered by each quiz. Generate and quiz cycles for your child and monitor how the child is progressing. 
        Be an integral part of your child learning. Start with boldung for mathematics - the language of science</p>
    </div>
    <div class="col-sm-5 text-center">
    <img src="/assets/images/landing-page/parent-share.png" width="200">
    
    </div>
</div>
